import Auth from '../modules/Authentication'
import {handleErrors, handleResponse} from '../modules/Utils'
import {apiUrl} from '../variables/index'

const headers = {}

export default class PayQuery {
  auth = new Auth()
  create = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}payQuery/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  list = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}payQuery/`, {
      headers: headers,
      method: 'GET',
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  get = key => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}payQuery/${key}`, {headers})
      .then(handleErrors)
      .then(handleResponse)
  }
  update = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}payQuery/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  remove = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}payQuery/`, {
      headers: headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    }).then(handleErrors)
    // .then(handleResponse)
  }
  activate = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`

    return fetch(`${apiUrl}payQuery/activate`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  suspend = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}payQuery/suspend`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  terminate = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}payQuery/terminate`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
}
